package com.veldekar.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.dom.GenericTag
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import kotlinx.datetime.LocalDate
import kotlinx.datetime.number
import org.jetbrains.compose.web.dom.Text

private val sessionDateFormatter: dynamic by lazy {
    js("new Intl.DateTimeFormat(undefined, { year: 'numeric', month: 'long', day: 'numeric' })")
}

private fun formatLocalizedDate(date: LocalDate): String = try {
    // Month is 0-indexed in JS Date
    val jsDate = kotlin.js.Date(date.year, date.month.number - 1, date.day)
    sessionDateFormatter.format(jsDate) as String
} catch (_: Throwable) {
    date.toString()
}

/**
 * Renders a session date with localization support using browser's Intl API.
 *
 * The date is localized to the user's browser locale using a shared
 * `Intl.DateTimeFormat` instance.
 *
 * @param isoDate The date in ISO 8601 format (e.g., "2026-01-19")
 */
@Composable
fun LocalizedSessionDate(isoDate: String, modifier: Modifier = Modifier) {
    LocalizedSessionDate(LocalDate.parse(isoDate), modifier)
}

/**
 * Renders a session date with localization support using browser's Intl API.
 *
 * The date is localized to the user's browser locale using a shared
 * `Intl.DateTimeFormat` instance.
 *
 * @param date The date to display
 */
@Composable
fun LocalizedSessionDate(date: LocalDate, modifier: Modifier = Modifier) {
    val isoDate = remember(date) { date.toString() }
    val localizedText = remember(date) { formatLocalizedDate(date) }

    GenericTag(
        "time",
        attrs = modifier.toAttrs {
            attr("datetime", isoDate)
        }
    ) {
        Text(localizedText)
    }
}
